import { graphGet } from '@/graph/client';
import { CAPABILITY_SCOPES } from '@/auth/scopes';
import type { MeProfile } from '@/graph/types';

/** C1 — read the signed-in admin's own profile. */
export function getMe(): Promise<MeProfile> {
  return graphGet<MeProfile>('/me', {
    scopes: CAPABILITY_SCOPES.C1.scopes,
    query: { $select: 'id,displayName,userPrincipalName,jobTitle' },
  });
}
